module.exports = __webpack_public_path__ + "static/CardOfDarkness3-2226d11439dc558b2919bb6178cb02ab.png";